import type { Lang } from '../../lib/i18n'

// Screen-local dictionary — mirrors features/staff/staff-i18n.ts so this bench stays
// inside files_locked. AR is Rook's, landed 2026-10-03 (bench §1.9); the lane copies it
// byte-for-byte and types no Arabic of its own.
const EN = {
  title: 'Dispatch',
  sendOut: 'Send out',
  onTheRoad: 'On the road',
  readyEmpty: 'No orders waiting to go out.',
  driversEmpty: 'No drivers set up.',
  onRun: 'on a run',
  sending: 'Sending…',
  sentTo: 'Sent with',
  reassign: 'Reassign',
  noActiveRuns: 'No runs on the road.',
  loadError: 'Couldn\'t load.',
  retry: 'Try again',
  refresh: 'Refresh',
}

const AR: typeof EN = {
  title: 'التوزيع',
  sendOut: 'إرسال',
  onTheRoad: 'في الطريق',
  readyEmpty: 'لا توجد طلبات بانتظار الإرسال.',
  driversEmpty: 'لا يوجد سائقون مسجّلون.',
  onRun: 'في جولة',
  sending: 'جارٍ الإرسال…',
  sentTo: 'أُرسل مع',
  reassign: 'إعادة تعيين',
  noActiveRuns: 'لا توجد جولات في الطريق.',
  loadError: 'تعذّر التحميل.',
  retry: 'حاول مجددًا',
  refresh: 'تحديث',
}

const DISPATCH_DICT = { en: EN, ar: AR } as const

export function dt<K extends keyof typeof EN>(lang: Lang, key: K): (typeof EN)[K] {
  return DISPATCH_DICT[lang][key]
}
